import { render } from "./dragSort.vue?vue&type=template&id=f4859ee4&scoped=true"
import script from "./dragSort.vue?vue&type=script&lang=js"
export * from "./dragSort.vue?vue&type=script&lang=js"

import "./dragSort.vue?vue&type=style&index=0&id=f4859ee4&lang=less&scoped=true"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4859ee4"]])

export default __exports__